import React from 'react';

export const AppleIcon = () => (
    <svg
        width="17"
        height="20"
        viewBox="0 0 20 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        style={{ flexShrink: 0 }}
    >
        <path
            d="M19.3613 8.18242C19.2188 8.29043 16.7031 9.67537 16.7031 12.7549C16.7031 16.3168 19.9042 17.577 20 17.6082C19.9853 17.685 19.4915 19.3339 18.3122 21.0141C17.2608 22.4926 16.1626 23.9688 14.4921 23.9688C12.8215 23.9688 12.3916 23.0207 10.4631 23.0207C8.58371 23.0207 7.91549 24 6.38742 24C4.85935 24 3.79315 22.6319 2.56725 20.9517C1.14728 18.9787 0 15.9136 0 13.0045C0 8.33843 3.10527 5.86379 6.16141 5.86379C7.78528 5.86379 9.13893 6.90549 10.1585 6.90549C11.1289 6.90549 12.6422 5.80138 14.4896 5.80138C15.1898 5.80138 17.7054 5.86379 19.3613 8.18242ZM13.6126 3.82598C14.3766 2.94029 14.9171 1.71137 14.9171 0.482448C14.9171 0.312031 14.9023 0.139214 14.8704 0C13.6273 0.0456046 12.1484 0.808881 11.2566 1.81938C10.5564 2.59706 9.90296 3.82598 9.90296 5.07171C9.90296 5.25893 9.9349 5.44614 9.94964 5.50615C10.0283 5.52055 10.156 5.53735 10.2837 5.53735C11.3991 5.53735 12.8019 4.80768 13.6126 3.82598Z"
            fill="black"
        />
    </svg>
);
